import axios from 'axios';

// ACTIONS
const HTTP_REQUEST = 'HTTP_REQUEST';
const HTTP_SUCCESS = 'HTTP_SUCCESS';
const HTTP_FAILURE = 'HTTP_FAILURE';
const HTTP_CLEAR = 'HTTP_CLEAR';

const defaultState = {
    isLoading: null,
    erreur: null,
    message: null,
    data: null,
    codeStatut: null,
};

export default class AbstractApiReducer {
    constructor(baseURL, timeout) {
        if (this.constructor === AbstractApiReducer) {
            throw new TypeError(
                'Abstract class "AbstractApiReducer" cannot be instantiated directly.',
            );
        }
        if (!baseURL) {
            throw new TypeError('baseURL is not defined.');
        }
        this.baseURL = baseURL;
        if (!timeout) {
            this.timeout = 60000;
        } else {
            this.timeout = timeout;
        }

        this.instance = axios.create({
            baseURL: this.baseURL,
            timeout: this.timeout,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            responseType: 'json',
            responseEncoding: 'utf8',
        });
    }

    getInstance() {
        return this.instance;
    }
}

const httpRequest = (context) => ({
    type: context + HTTP_REQUEST,
    payload: {},
    context,
});

const httpSuccess = (response, context) => ({
    type: context + HTTP_SUCCESS,
    payload: response,
    context,
});

export const updateData = (data, context) => (dispatch) => {
    dispatch(
        httpSuccess(
            {
                data: { data },
            },
            context,
        ),
    );
};

export const httpFailure = (error, context) => ({
    type: context + HTTP_FAILURE,
    payload: error,
    context,
});

const reinitialise = (context) => ({
    type: context + HTTP_CLEAR,
    payload: {},
    context,
});

export const reinitialiseAPI = (context) => (dispatch) => {
    dispatch(reinitialise(context));
};

export const getAPI = (clientApiReducer, url, context) => (dispatch) => {
    dispatch(httpRequest(context));
    clientApiReducer
        .getInstance()
        .get(url)
        .then((response) => dispatch(httpSuccess(response, context)))
        .catch((error) => dispatch(httpFailure(error.response, context)));
};

export const postAPI = (clientApiReducer, url, data, context) => (dispatch) => {
    dispatch(httpRequest(context));
    return clientApiReducer
        .getInstance()
        .post(url, data)
        .then((response) => dispatch(httpSuccess(response, context)))
        .catch((error) => dispatch(httpFailure(error.response, context)));
};

export const putAPI = (clientApiReducer, url, data, context) => (dispatch) => {
    dispatch(httpRequest(context));
    clientApiReducer
        .getInstance()
        .put(url, data)
        .then((response) => dispatch(httpSuccess(response, context)))
        .catch((error) => dispatch(httpFailure(error.response, context)));
};

export const patchAPI = (clientApiReducer, url, data, context) => (dispatch) => {
    dispatch(httpRequest(context));
    clientApiReducer
        .getInstance()
        .patch(url, data)
        .then((response) => dispatch(httpSuccess(response, context)))
        .catch((error) => dispatch(httpFailure(error.response, context)));
};

export const deleteAPI = (clientApiReducer, url, context) => (dispatch) => {
    dispatch(httpRequest(context));
    clientApiReducer
        .getInstance()
        .delete(url)
        .then((response) => dispatch(httpSuccess(response, context)))
        .catch((error) => dispatch(httpFailure(error.response, context)));
};

export const APIReducer = (context, state = defaultState, action = {}) => {
    switch (action.type) {
        case context + HTTP_REQUEST:
            return {
                ...defaultState,
                isLoading: true,
            };
        case context + HTTP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                erreur: false,
                data: action.payload.data.data,
                message: action.payload.data.message,
                codeStatut: action.payload.status,
            };
        case context + HTTP_FAILURE:
            if (action.payload) {
                return {
                    ...state,
                    isLoading: false,
                    erreur: true,
                    data: action.payload.data.data,
                    message: action.payload.data.message,
                    codeStatut: action.payload.status,
                };
            }

            return {
                ...state,
                isLoading: false,
                erreur: true,
                data: null,
                message: null,
                codeStatut: 503,
            };

        case context + HTTP_CLEAR:
            return defaultState;
        default:
            return state;
    }
};
